
import React, { useState } from 'react';
import { Ruler, Check, X } from 'lucide-react';

interface CalibrationModalProps {
  pixelDistance: number;
  onConfirm: (meters: number) => void;
  onCancel: () => void;
}

const CalibrationModal: React.FC<CalibrationModalProps> = ({ pixelDistance, onConfirm, onCancel }) => {
  const [meters, setMeters] = useState<string>('5');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const val = parseFloat(meters);
    if (val > 0) onConfirm(val);
  };

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/80 backdrop-blur-sm p-4 animate-in fade-in duration-200">
      <div className="bg-slate-900 border border-cyan-500/50 rounded-xl shadow-[0_0_30px_rgba(6,182,212,0.2)] w-full max-w-sm p-6 transform transition-all scale-100 relative overflow-hidden">
        
        {/* Decorative corner */}
        <div className="absolute top-0 right-0 w-16 h-16 bg-gradient-to-bl from-cyan-500/20 to-transparent pointer-events-none"></div>

        <h2 className="text-lg font-rajdhani font-bold text-white mb-2 flex items-center gap-2 uppercase tracking-wide">
            <Ruler className="text-cyan-400" size={20}/> Mastelio kalibravimas
        </h2>
        <p className="text-cyan-100/60 text-xs font-mono mb-6 leading-relaxed">
            ATKARPOS ILGIS PIKSELIAIS: <span className="text-cyan-300 font-bold">{pixelDistance.toFixed(0)} PX</span>.
            <br/>
            ĮVESKITE TIKRĄJĮ ATSTUMĄ:
        </p>

        <form onSubmit={handleSubmit} className="space-y-6">
            <div>
                <div className="relative group">
                    <input 
                        type="number" 
                        step="0.1" 
                        min="0.1"
                        autoFocus
                        value={meters}
                        onChange={e => setMeters(e.target.value)}
                        className="w-full bg-black/40 border border-slate-600 rounded-lg p-3 text-cyan-300 font-mono text-xl focus:border-cyan-400 focus:shadow-[0_0_15px_rgba(6,182,212,0.1)] outline-none transition-all"
                    />
                    <span className="absolute right-4 top-4 text-slate-500 text-sm font-bold">METRAI</span>
                </div>
            </div>
            
            <div className="flex gap-3 justify-end pt-2">
                <button 
                    type="button" 
                    onClick={onCancel} 
                    className="px-5 py-2 text-slate-400 hover:text-white text-xs font-bold uppercase tracking-wider transition-colors border border-transparent hover:border-white/10 rounded"
                >
                    Atšaukti
                </button>
                <button 
                    type="submit" 
                    className="px-6 py-2 bg-cyan-600 hover:bg-cyan-500 text-white rounded font-rajdhani font-bold text-sm uppercase tracking-wider flex items-center gap-2 shadow-[0_0_15px_rgba(6,182,212,0.3)] transition-all transform hover:scale-105"
                >
                    <Check size={16}/> Patvirtinti
                </button>
            </div>
        </form>
      </div>
    </div>
  );
};

export default CalibrationModal;
